var aria = {
  product_page: function () {

    $('body').on('click', '.pdacd_heading', function () {
      tab_detail($(this));
    }).on('keydown', function (ev) {
      if (ev.which == 13) {
        //tab_detail($(this));
      }
    });

    function tab_detail(that) {
      that.toggleClass('active');
      that.next('.pdacd_description').slideToggle();
    }



    // option list
    $('body').on('click', '.option_value', function () {
      //	option_list($(this)); 
    }).on('keyup', '.option_value', function (ev) {
      if (ev.which == 13) {
        //option_list($(this));
        //$(this)[0].focus();
      }
    });

    function option_list(that) {
      var val = that.data('val');

      var index = that.closest('.option_list').data('index');

      var label = that.attr('aria-label') + ' selected';
      var selected_label = that.closest('.option_list').find('.option_value.selected').attr('aria-label');
      if (typeof selected_label !== 'undefined') {
        selected_label = selected_label.replace("selected", "");
        that.closest('.option_list').find('.option_value.selected').attr('aria-label', selected_label);
      }
      // that.attr('aria-label', label); 
      that.closest('.option_list').find('.option_value').removeClass('selected');
      that.addClass('selected');
      $('.swatch__options[data-variant-option-index="' + index + '"] .swatch-element[data-value="' + val + '"] label').trigger('click').addClass('active');
    }

  },
  cookie: function () {
    $('body').on('click', '.cc-btn', function () {
      $('.cc-window').fadeOut();
    });
  },
  mincart: function () {

    $('body').on('click', '.js-im-add-cart', function () {
      setTimeout(function () {
        get_cart();
      }, 2500);
    });


    $('.mmc_shopping_link a').on('click', function () {
      var url = $(this).attr('href');
      window.location.href = url;
    });

    $('.cart__remove').on('click', function () {
      console.log('remove');
      setTimeout(function () {
        get_cart();
      }, 500);
    });

    $('.header-cart__button, .header-cart__icon').on('click', function (e) {
      e.preventDefault();
      cart_btn();
    }).on('keypress', function (e) {
      e.preventDefault();
      if (e.keyCode == 13 || e.keyCode == 32) {
        cart_btn();
      }
    });

    function cart_btn() {
      $('.min_cart, body').addClass('active');
      $('#PopupCartID')[0].focus();
      setTimeout(function () {
        $('#PopupCartID')[0].focus();
      }, 1500);
    }


    $('.min_bg, .min_close').on('click', function () {
      $('.min_cart, body').removeClass('active');
    });

    $('body').on('click', '.remove_item', function (e) {
      e.preventDefault();
      var line = $(this).data('line');
      update_line(line, 0);
      // $(this).closest('.mmc_items').hide();
    });

    $('body').on('click', '.mmc_sign', function () {
      var qty = parseInt($(this).closest('.mmc_qty').find('.quantity-input').val());
      var line = $(this).closest('.mmc_qty').data('line-item-key');
      var id = $(this).closest('.mmc_qty').find('.quantity-input').data('id');
      if ($(this).hasClass('mmc_min')) {
        qty = qty - 1;
      } else {
        qty = qty + 1;
      }

      update_qty(qty, id)

      // update_line(line, qty);

    });

    $('body').on('change', '.quantity-input', function () {
      var qty = parseInt($(this).val());
      var line = $(this).data('line-id');
      var id = $(this).data('id');

      //update_line(line, qty);
      update_qty(qty, id)
    });


    $('body').on('submit', 'form[action="/cart/add"]', function (e) {
      e.preventDefault();
      addItem($(this));
    });

    function addItem(that) {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: that.serialize(),
        success: function (cart) {
          get_cart();
        },
        error: function (response) {
          //alert(response);
        }
      });
    }


    function update_line(line, qty) {
      var url = '/cart/change?line=' + line + '&quantity=' + qty;

      $.ajax({
        type: 'POST',
        url: url,
        dataType: 'json',
        success: function (cart) {
          get_cart();
        },
        error: function (response) {
          location.reload();
        }
      });
    }

    function update_qty(qty, id) {
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        data: {
          id: id,
          quantity: qty,
        },
        success: function (resp) {
          //location.reload();
          get_cart();
        }
      });
    }


    function get_cart() {
      jQuery.getJSON('/cart.js', function (cart) {
        console.log(cart);
        var html = '', count = 0;
        console.log(cart.items.length);

        if (cart.items.length == 0) {
          $('.mmc_item_box').html('<p class="empty_cart">Empty Cart</p>');
        }

        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i];
          var forloop = i + 1;

          if (item.product_title != 'Gift Box') {
            count += item.quantity;
            html += '<div class="mmc_items">' +
              '<div class="mmc_img">' +
              '<a href="' + item.url + '" class="cart_page_image">' +
              '<img src="' + item.image + '"/>' +
              '</a>' +
              '</div>' +
              '<div class="mmc_detail">' +
              '<div class="mmc_title"><a href="' + item.url + '">' + item.title + '</a> </div>' +
              '<div class="mmc_price" tabindex="0">' + Shopify.formatMoney(item.line_price) + ' </div>' +
              '<div class="mmc_qty" data-line-item-key=' + forloop + '>' +
              '<div aria-label="Cart quantity minus" class="mmc_sign mmc_min" tabindex="0" role="button"><span class="icon "><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="minus"><rect x="5" y="46" width="90" height="8"/></g></svg></span></div>' +
              '<input class="quantity-input" data-id="' + item.id + '"  type="text" name="quantity" value="' + item.quantity + '" data-line-id="' + forloop + '">' +
              '<div aria-label="Cart quantity plus" class="mmc_sign mmc_plus" tabindex="0" role="button"><span class="icon "><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="plus"><polygon points="95 46 54 46 54 5 46 5 46 46 5 46 5 54 46 54 46 95 54 95 54 54 95 54 95 46"/></g></svg></span></div>' +
              '</div>' +
              '</div>' +
              '<div class="mmc_close">' +
              '<button class="close remove_item quantity_changed" tabindex="0" aria-label="Remove item" data-line="' + forloop + '">' +
              '<span class="icon "><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="x"><polygon points="97.83 7.83 92.17 2.17 50 44.34 7.83 2.17 2.17 7.83 44.34 50 2.17 92.17 7.83 97.83 50 55.66 92.17 97.83 97.83 92.17 55.66 50 97.83 7.83"/></g></svg></span>' +
              '</button>' +
              '</div>' +
              '</div>';
          }
        }

        $('.mmc_item_box').html(html);
        $('.mmc_total_price').html(Shopify.formatMoney(cart.total_price));
        $('.min_cart, body').addClass('active');
        $('.header-cart__count, [data-bind="itemCount"]').html(count);

        if (count > 0) {
          $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        } else {
          $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        }
      });
    }
  },
  tab_show_ada: function () {

    setTimeout(function () {
      $('.header__menu-items .navbar-item').each(function () {
        var label = $(this).find('.navbar-link').text();
        if ($(this).hasClass('has-mega-menu')) {
          $(this).find('.navbar-link').attr('aria-label', label + ' drop down menu press tab to open');
        } else {
          $(this).find('.navbar-link').attr('aria-label', label + ' menu');
        }
      });


      $('.product-gallery__main').find('.flickity-button').attr('tabindex', '-1');
      $('.product-gallery__main').find('.flickity-button').attr('aria-hidden', 'true');

    }, 150);

    setTimeout(function () {
      $('.boost-pfs-filter-top-sorting, .template-collection .product-thumbnail__title, .template-collection .product__thumbnail, .template-collection .product-thumbnail__price, .shopify-installments__content, .shopify-installments__learn-more').attr('tabindex', 0);
      $('.boost-pfs-filter-top-sorting').attr('aria-label', 'Sort by');

      $('#boost-pfs-filter-tree-pf-p-price .boost-pfs-filter-option-item-list .boost-pfs-filter-option-item').each(function () {
        var html = $(this).find('.boost-pfs-filter-option-value').text();
        $(this).find('.boost-pfs-filter-option-value').attr('aria-label', 'checkbox ' + html);
      });

    }, 4000);


    /*
     $(".navbar-item").on('keyup', function(e) {  
      if($(this).hasClass('has-mega-menu')){
       var keyCode = e.keyCode || e.which; 
        if (keyCode == 9) { 
           $(this).find('.mega-menu__section').addClass('is-active');
           $(this).find('.mega-menu__section .menu__heading')[0].focus();
       } 
      }else{
        $('.mega-menu__section').removeClass('is-active');
     }
    }); 
    */

    $(".product__imageContainer a").on('keyup', function (e) {
      var keyCode = e.keyCode || e.which;
      if (keyCode == 9) {
        $(this).closest('.product-image__wrapper').find('.thumbnail-overlay__container').addClass('active');
      }
    });

    $(".product-thumbnail a").on('keydown', function (e) {
      var keyCode = e.keyCode || e.which;
      if (keyCode == 9) {
        $(this).closest('.product-wrap').find('.thumbnail-overlay__container').removeClass('active');
      }
    });

    $('body').on('keydown', '.js-quick-shop-link', function (ev) {
      if (ev.which == 13) {
        $(this).trigger("click");
      }
    });
    // Global variable to keep track of the selected swatch for focus restoration
    window.lastSelectedSwatch = null;
    window.lastSelectedSwatchTime = 0;

    $('body').on('keydown', '.swatch__option', function (ev) {
      if (ev.which == 13) {
        var $active = $(document.activeElement);
        var $input = $(this).find('input');

        // Find the closest stable container and mark it
        var $container = $(this).closest('.fancybox-content, .js-product_section, .product-wrap, .product__thumbnail, .thumbnail, form');
        $('.active-swatch-container').removeClass('active-swatch-container'); // Clear any old ones
        $container.addClass('active-swatch-container');

        if ($input.length) {
          window.lastSelectedSwatch = {
            name: $input.attr('name'),
            value: $input.val(),
            isInputFocused: $active.is('input'),
            isDivFocused: $active.hasClass('swatch-element')
          };
          window.lastSelectedSwatchTime = Date.now();

          // Start a temporary polling loop for 500ms to catch any delayed/multi-stage updates
          var checkInterval = setInterval(function () {
            if (!window.lastSelectedSwatch || Date.now() - window.lastSelectedSwatchTime > 500) {
              clearInterval(checkInterval);
              $('.active-swatch-container').removeClass('active-swatch-container');
              window.lastSelectedSwatch = null;
            } else {
              restoreSwatchFocus();
            }
          }, 50);
        }
        $(this).find('label').trigger('click');
      }
    });

    // Helper to update swatch ARIA labels and selected states dynamically
    function updateSwatchAriaLabels() {
      $('.swatch__option').each(function() {
        var $option = $(this);
        var $input = $option.find('input');
        var $swatchDiv = $option.find('.swatch-element');
        
        if ($input.length && $swatchDiv.length) {
          var val = $input.val();
          var isChecked = $input.prop('checked');
          var isSoldOut = $input.prop('disabled') || $input.attr('data-variant-option-available') === 'false';
          
          var expectedLabel = val;
          if (isSoldOut) {
            expectedLabel += ' sold out';
          } else if (isChecked) {
            expectedLabel += ' selected';
          }
          
          var expectedSelected = isChecked ? 'true' : 'false';
          
          if ($input.attr('aria-label') !== expectedLabel) {
            $input.attr('aria-label', expectedLabel);
          }
          if ($swatchDiv.attr('aria-label') !== expectedLabel) {
            $swatchDiv.attr('aria-label', expectedLabel);
          }
          if ($swatchDiv.attr('aria-selected') !== expectedSelected) {
            $swatchDiv.attr('aria-selected', expectedSelected);
          }
        }
      });
    }

    // Run once on script load
    updateSwatchAriaLabels();

    // Helper to restore focus to the selected swatch
    function restoreSwatchFocus() {
      if (!window.lastSelectedSwatch) return;

      // If the 500ms window has passed, clear it and stop
      if (Date.now() - window.lastSelectedSwatchTime > 500) {
        $('.active-swatch-container').removeClass('active-swatch-container');
        window.lastSelectedSwatch = null;
        return;
      }

      var name = window.lastSelectedSwatch.name;
      var value = window.lastSelectedSwatch.value;

      // Find the active container first
      var $container = $('.active-swatch-container');
      var $newInput = $();

      if ($container.length) {
        $newInput = $container.find('input[name="' + name + '"][value="' + value + '"]');
      }

      // Fallback if container is not found or input not found inside it
      if (!$newInput.length) {
        $newInput = $('.fancybox-content input[name="' + name + '"][value="' + value + '"]');
      }
      if (!$newInput.length) {
        $newInput = $('input[name="' + name + '"][value="' + value + '"]');
      }

      if ($newInput.length) {
        updateSwatchAriaLabels();

        var $targetToFocus = $newInput;

        // If the input is disabled (e.g. option is sold out), we focus the visible swatch-element instead
        if ($newInput.prop('disabled') || window.lastSelectedSwatch.isDivFocused) {
          var $swatchDiv = $newInput.closest('.swatch__option').find('.swatch-element');
          if ($swatchDiv.length) {
            $targetToFocus = $swatchDiv;
          }
        }

        // Only focus if not already focused to prevent infinite loop / scroll jumping
        if (document.activeElement !== $targetToFocus[0]) {
          $targetToFocus.focus();
        }
      }
    }

    // Observer to detect when swatches are re-rendered and restore focus
    var swatchObserver = new MutationObserver(function () {
      updateSwatchAriaLabels();
      if (window.lastSelectedSwatch) {
        restoreSwatchFocus();
      }
    });

    swatchObserver.observe(document.body, {
      childList: true,
      subtree: true
    });


    $('body').on('keydown', '.boost-pfs-filter-option-title .boost-pfs-filter-button', function (ev) {
      if (ev.which == 13) {
        // $(this).closest('.boost-pfs-filter-option').find('.boost-pfs-filter-option-item-list .boost-pfs-filter-option-item:first-child button').addClass('active')
        // $(this).closest('.boost-pfs-filter-option').find('.boost-pfs-filter-option-item-list .boost-pfs-filter-option-item:first-child button')[0].focus();
      }
    });


  },
  space_ada: function () {


    $(".navbar-item").on('keypress', function (e) {
      if ($(this).hasClass('has-dropdown')) {
        if (e.keyCode == 13 || e.keyCode == 32) {
          e.preventDefault();
          $(this).find('.mega-menu__section').addClass('is-active');
          $(this).find('.mega-menu__section .show_drowdonw')[0].focus();
        }
      } else {
        $('.mega-menu__section').removeClass('is-active');
      }
    });

    $('body').on('keydown', ".has-dropdown", function (e) {
      if (e.keyCode == 13 || e.keyCode == 32) {
        $(this).find('.mega-menu__section .show_drowdonw')[0].focus();
      }
    });

    $('.navbar-link').on('keypress', function (e) {
      if (e.keyCode == 13 || e.keyCode == 32) {
        if (!$(this).closest('.navbar-item').hasClass('has-dropdown')) {
          var url = $(this).attr('href');
          window.location = url;
        }
      }
    });

    $('.social-icons a').on('keypress', function (e) {
      if (e.keyCode == 13 || e.keyCode == 32) {
        var url = $(this).attr('href');
        window.open(url, '_blank');
      }
    });

    $('.open_link, .mega-menu__linklist-link, .cart__remove-btn').on('keypress', function (e) {
      if (e.keyCode == 13 || e.keyCode == 32) {
        var url = $(this).attr('href');
        window.location = url;
      }
    });
    $('body').on('keypress', '.product__imageContainer a, .item__title a, .mmc_title a', function (e) {
      if (e.keyCode == 13 || e.keyCode == 32) {
        var url = $(this).attr('href');
        window.location = url;
      }
    });
    $('body').on('keypress', '.qty_inverse, .mmc_sign, .remove_item, .min_cart_close,  [action="/cart/add"] [type="submit"], .option_value [data-show-search-trigger], .quick_shop, .klaviyo-form [type="button"], .bottom_link_popup, .cstmsv_close, .cstmsv_btn_style', function (e) {
      if (e.keyCode == 13 || e.keyCode == 32) {
        $(this).trigger('click');
      }
    });

    // filter
    $('body').on('keypress', '.boost-pfs-filter-button', function (e) {
      if (e.keyCode == 13 || e.keyCode == 32) {
        // $(this).trigger('click');
      }
    });


  }
}

$(function () {
  aria.product_page();
  aria.cookie();
  aria.mincart();
  aria.tab_show_ada();

  aria.space_ada();


});

$(window).scroll(function () {
  var top = $(window).scrollTop();
  if (top > 200) {
    $('#header').addClass('active_subhead');
  } else {
    $('#header').removeClass('active_subhead');
  }

});

$(document).on('keydown', '.navbar-item.has-mega-menu', function (e) {
  if (e.keyCode === 9 && e.shiftKey) { // Shift + Tab
    if ($(this).find('.mega-menu__section').find('.column.mega-menu__block').first().find('.mega-menu__content').is(':focus')) {
      $(this).find('.mega-menu__section').removeClass('is-active');
      // console.log('First element ->');
    }

  } else if (e.keyCode === 9) { // Tab
    $(this).find('.mega-menu__section').addClass('is-active');
    //  console.log('forward ->');
  }

  if ($(this).find('.mega-menu__section').find('.column.mega-menu__block').last().find('.mega-menu__content').is(':focus')) {
    $(this).find('.mega-menu__section').removeClass('is-active');
    // console.log('Last element ->');
  }

});

// $(document).on('keydown', function(e) {
//     if (e.keyCode === 9 && e.shiftKey) { // Shift + Tab
//         var nextElement = $('.navbar-item.has-mega-menu').next();
//         console.log('Shift+Tab backward <-');
//         $('.navbar-item.has-mega-menu').find('.mega-menu__section').addClass('is-active');
//         $(this).find('.mega-menu__section').find('.column.mega-menu__block').last().find('.mega-menu__content').focus();

//     }
// });


$(document).ready(function () {
  $('.mega-menu__content.content').keypress(function (event) {
    var keycode = (event.keyCode ? event.keyCode : event.which);
    if (keycode == '13') {
      window.location.href = $(this).data('url');
    }
  });
});


$(document).on('keydown', '.image__container.product__imageContainer', function (e) {
  if (e.keyCode === 9) {

    var ovarlay_content = $(this).find('.thumbnail-overlay__container');
    var button_container = $(this).find('.thumbnail-overlay__container .quick-shop__buttons');
    ovarlay_content.css('display', 'flex');
    button_container.css('display', 'flex');
  }
});

// Track mouse/touch interactions to distinguish from keyboard and screen readers (UserWay)
window.isMouseDown = false;
$(document).on('mousedown touchstart', function () {
  window.isMouseDown = true;
  clearTimeout(window.mouseDownTimer);
  window.mouseDownTimer = setTimeout(function () {
    window.isMouseDown = false;
  }, 200);
});

// Accessibility: Open dropdown/mega menu when focus enters (via keyboard/UserWay)
$(document).on('focusin', '.navbar-item.has-mega-menu, .navbar-item.has-dropdown', function () {
  if (!window.isMouseDown) {
    if ($(this).hasClass('has-mega-menu')) {
      $(this).find('.mega-menu__section').addClass('is-active');
    }
    $(this).addClass('show-dropdown is-opened');
  }
});

// Accessibility: Close dropdown/mega menu when focus leaves (via keyboard/UserWay)
$(document).on('focusout', '.navbar-item.has-mega-menu, .navbar-item.has-dropdown', function (e) {
  var $this = $(this);
  setTimeout(function () {
    if (!window.isMouseDown && !$this.find(':focus').length) {
      $('.mega-menu__section').removeClass('is-active');
      $this.removeClass('is-opened show-dropdown');
      $this.find('.navbar-dropdown').removeClass('show-nested-dropdown');
      $this.find('.has-submenu input').prop("checked", false);
    }
  }, 50);
});